import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useFood } from "./FoodLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = useFood();
  const items = data?.facilities || [];
  return (
    <div data-testid="food-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="green" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="food-facilities"
          accentChipClass="bg-emerald-500/10 text-emerald-700 ring-1 ring-emerald-500/20"
        />
      </PageBody>
    </div>
  );
}
